import {
    CHANGE_CURRENT_HELP_VIEW,
    HELP_CHANGE_VIEWABLE_STATE,
    HELP_FETCHING,
    HELP_FETCHING_ERROR,
    HELP_FETCHING_SUCCESS,
    HelpActionTypes
} from "../../actions/common/HelpActions";
import {Help} from "../../models/common/Help";
import {getInitialRequestState, RequestState} from "../../models/common/RequestState";
import {Nullable} from "../../models/common/Nullable";

export interface HelpState {
    currentView: string
    isViewable: boolean
    entries: { [ key: string ]: Nullable<Help> }
    request: RequestState
}

const initialState: HelpState = {
    currentView: "",
    isViewable: false,
    entries: {},
    request: getInitialRequestState()
};

export const HelpReducer = ( state = initialState, action: HelpActionTypes ) => {
    switch( action.type ) {
        case HELP_FETCHING:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case HELP_FETCHING_SUCCESS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    [ `${action.viewIdentifier}_${ action.languageIdentifier }`]: action.payload
                },
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case HELP_FETCHING_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case HELP_CHANGE_VIEWABLE_STATE:
            return {
                ...state,
                isViewable: action.isViewable
            };
        case CHANGE_CURRENT_HELP_VIEW:
            return {
                ...state,
                currentView: action.viewIdentifier
            };
        default:
            return state;
    }
};